import { makeApiUrl } from '../http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { RemotePostQboAccounts } from 'data/usecases/remote-post-qbo-accounts';
import { PostQboAccounts } from 'domain/usecases/post-qbo-accounts';

export const makeRemotePostQboAccounts = (): PostQboAccounts => {
  return new RemotePostQboAccounts(makeApiUrl('/accounts'), makeAuthorizeHttpClientDecorator());
};
